export const T = {
  en_GB: {
    signInAs: (name: string) => `Sign in as ${name}`,
    signInAsRepresentative: (representative: string, member: string) =>
      `Sign in as ${representative} on behalf of ${member}`,
    noSignInMethod: "You can't sign in with this link yet — contact your advisor.",
    chooseMethod: "Choose how you'd like to receive your verification code",
    sendCodeViaEmail: "Send Code via Email",
    sendCodeViaSMS: "Send Code via SMS",
    orSignInWith: "Or sign in with",
    bankIdMitId: "BankID / MitID",
    secureAuth: "Secure authentication using your national eID",
    enterCodeToContinue: "Enter the verification code to continue",
    authFailed: "Authentication failed",
    failedToSendCode: "Failed to send verification code",
    codeSentEmail: "Verification code sent via email!",
    codeSentSMS: "Verification code sent via SMS!",
    identityMismatch:
      "This link belongs to another person. Please sign in with your own national eID.",
    tryAgain: "Try again",
    // Unavailable-link reasons (PublicLinkUnavailableReason) — kept word-for-word
    // in sync with `/p/:token/auth` and `/p/error`.
    linkExpired: "This link has expired. Ask your advisor for a new one.",
    linkRevoked: "This link has been withdrawn by your advisor.",
    representativeRemoved:
      "This link was issued to a representative who is no longer registered for this client. Contact your advisor.",
    representativeChanged:
      "Who signs in for this client has changed, so this link no longer works. Ask your advisor for a new one.",
    memberRemoved:
      "This link was issued to a member who is no longer part of this group. Contact your advisor.",
    linkNotFound: "This link is not valid.",
  },
  nb_NO: {
    signInAs: (name: string) => `Logg inn som ${name}`,
    signInAsRepresentative: (representative: string, member: string) =>
      `Logg inn som ${representative} på vegne av ${member}`,
    noSignInMethod: "Du kan ikke logge inn med denne lenken ennå — kontakt rådgiveren din.",
    chooseMethod: "Velg hvordan du vil motta verifiseringskoden",
    sendCodeViaEmail: "Send kode via e-post",
    sendCodeViaSMS: "Send kode via SMS",
    orSignInWith: "Eller logg inn med",
    bankIdMitId: "BankID / MitID",
    secureAuth: "Sikker autentisering med nasjonal eID",
    enterCodeToContinue: "Skriv inn verifiseringskoden for å fortsette",
    authFailed: "Autentisering mislyktes",
    failedToSendCode: "Kunne ikke sende verifiseringskode",
    codeSentEmail: "Verifiseringskode sendt via e-post!",
    codeSentSMS: "Verifiseringskode sendt via SMS!",
    identityMismatch: "Denne lenken tilhører en annen person. Vennligst logg inn med din egen eID.",
    tryAgain: "Prøv igjen",
    linkExpired: "Denne lenken har utløpt. Be rådgiveren din om en ny.",
    linkRevoked: "Denne lenken er trukket tilbake av rådgiveren din.",
    representativeRemoved:
      "Denne lenken ble utstedt til en representant som ikke lenger er registrert for denne kunden. Kontakt rådgiveren din.",
    representativeChanged:
      "Den som skal logge inn for denne klienten er endret, så denne lenken virker ikke lenger. Be rådgiveren din om en ny.",
    memberRemoved:
      "Denne lenken ble utstedt til et medlem som ikke lenger er en del av denne gruppen. Kontakt rådgiveren din.",
    linkNotFound: "Denne lenken er ikke gyldig.",
  },
} as const;
